<template>
    <Head>
        <title>Статистика уведомлений в телеграмм</title>
    </Head>

    <authenticated-layout>

        <template #header>
            <navigation/>
        </template>


        <div class="flex flex-col gap-6 p-6 bg-white">

            <form @submit.prevent="getStat" action="#" method="post" class="flex flex-row justify-end items-end gap-4">
<!--                <v-input v-model="checkStat.from" :error="checkStat.errors.from" type="datetime-local" label="Дата начала"/>-->
<!--                <v-input v-model="checkStat.to" :error="checkStat.errors.to" type="datetime-local" label="Дата окончания"/>-->
                <v-button>Получить за вчера</v-button>
            </form>
            <pre class="text-xs">{{ resultStat }}</pre>

            <div class="grid grid-cols-9 gap-4 p-4 border-b" v-for="row in statistic.data">
                <div>
                    <span class="text-sm text-gray-500">Интервал</span>
                    <div>{{ row.interval }}</div>
                </div>
                <div class="col-span-7 flex flex-row gap-4">
                    <div v-for="(data, index) in row.data">
                        <span class="text-sm text-gray-500">{{ index }}</span>
                        <pre class="text-xs border-l pl-1">{{ data }}</pre>
                    </div>
                </div>
                <div>
                    <span class="text-sm text-gray-500">Дата (UTC)</span>
                    <div class="text-sm">{{ moment(row.created_at).utc().format('L LTS') }}</div>
                </div>
            </div>

            <Pagination class="my-4" :links="statistic.links" />
        </div>

    </authenticated-layout>

</template>

<script>
import {ref} from "vue";
import moment from 'moment';
import {Head, Link} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import Navigation from '@/Components/Navigation/Administration';
import VInput from '@/Components/Input';
import VButton from '@/Components/Button';
import Pagination from "@/Components/Pagination.vue";

export default {
    components: {
        Pagination,
        Head, Link,
        AuthenticatedLayout,
        Navigation,
        VInput,
        VButton,
    },
    props: {
        statistic: Object,
    },
    setup() {
        const checkStat = {
            from: moment().add(-1, 'day').format('YYYY-MM-DDT00:00'),
            to: moment().startOf('day').format('YYYY-MM-DDT00:00'),
        }
        let resultStat = ref('');
        return {checkStat, resultStat}
    },
    methods: {
        moment,
        getStat() {
            axios.post(this.route('admin.telegram.get'), this.checkStat)
                .then((res) => {
                    const {result} = res.data;
                    this.resultStat = result;
                });
        },
    },
}
</script>
